import * as React from "react";
import { Typography } from "@mui/material/";
import InnerPage from "../components/InnerPage";
import Users from "../components/Users";

export default function UsersScreen({ user }) {
  return (
    <InnerPage title="Customers">
      <Users user={user} />
    </InnerPage>
  );
}
